

import { Buffer } from "buffer";
import React, { useState, useEffect } from "react";
import { useForm, 
  // Controller
 } from "react-hook-form";
import {
  Box,
  Button,
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  // Autocomplete,
  // TextField,
  Card,
  Stack,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Header from "../components/Header";
import { useNavigate, useLocation } from "react-router-dom";
const { encryptPayload, decryptPayload } = require("../utils/custom-hash");
const qz = require("qz-tray");

function Print() {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [ticketModalOpen, setTicketModalOpen] = useState(false);
  const [ticketNumber, setTicketNumber] = useState("");
  const [ticketToken, setTicketToken] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const responseData = state?.responseData;
  const appointmentDetails = responseData || {};

  useEffect(() => {
    let timer;
    if (ticketModalOpen) {
      timer = setTimeout(() => {
        navigate("/");
      }, 60000);

      return () => clearTimeout(timer);
    }
  }, [ticketModalOpen, navigate]);


  const handlePrintViaQZTray = async (ticketData, settings) => {
      // Helper function to pad string to fixed length
      const padString = (str, length) => {
        if (!str) return "".padEnd(length, " ");
        return str.length > length
          ? str.substring(0, length)
          : str.padEnd(length, " ");
      };
    
      const ticketContent = [
        "===============================",
        `      ${ticketData?.branchName || "Branch Name"}`,
        "===============================",
        `Ticket No   : ${ticketData.token}`,
        `Service     : ${ticketData.serviceName}`,
        `Status      : ${ticketData.status}`,
        `Issued At   : ${new Date(ticketData.issueTime).toLocaleString()}`,
        // `Name        : ${ticketData.customerName}`,
        // `Email       : ${ticketData.customerEmail}`,
        // `Contact     : ${ticketData.customerContact}`,
        "-------------------------------",
        "Thank you for visiting!",
        "===============================",
        "" // extra line for spacing
      ].join("\n");  // <== Guarantees clean newlines
    
      const cutCommand = '\x1D\x56\x42\x00'; // Full cut command (for Epson-style printers)
    
      try {
        await qz.websocket.connect();
        const printerData = await qz.printers.getDefault();
        // console.log("FOUND PRINTER:", printerData); // Check the printer details
    
        let config = qz.configs.create(printerData); // Get printer config
    
        // First print ticket content
        await qz.print(config, [{
          type: 'raw',
          flavor: 'plain',
          data: ticketContent + cutCommand
        }]);
    
        setTicketModalOpen(true); // Display modal after printing
    
      } catch (err) {
        console.error("Error during printing:", err);
      } finally {
        await qz.websocket.disconnect();
      }
    };

  const onSubmit = async (data) => {
    try {
      setErrorMessage("");
      const payload = {
        branchId: appointmentDetails.branchId,
        serviceId: appointmentDetails.serviceId,
        customerName: appointmentDetails.name,
        customerMail: appointmentDetails.email,
        customerContact: appointmentDetails.contactNumber,
        customerType: "Online",
        referenceCode: appointmentDetails.referenceCode,
      };

      const encryptedPayload = await encryptPayload(payload);
      // console.log("Ticket Payload:", encryptedPayload);

      const response = await fetch(
        `${process.env.REACT_APP_ASERVER}/api/kiosk/ticket/generate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({

            encryptedPayload: encryptedPayload,

          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json(); // Parse the error message
        setErrorMessage(errorData.message || "Failed to generate ticket"); // Update error message state
        return; // Exit the function if there is an error
      }
      const result = await response.json();
      setTicketNumber(result.ticket);
      setTicketToken(result.ticketToken);
      setTicketModalOpen(true);
    } catch (error) {
      console.error("Error generating ticket:", error);
      alert("Error generating ticket. Please try again later.");
    }
  };

  const handlePrint = async () => {
    try {
      const payload = {
        ticketNumber,
        branchId: appointmentDetails.branchId,
      };

      const encryptedprintPayload = await encryptPayload(payload);
      // console.log("Encrypted Branch ID:", encryptedprintPayload);


      const response = await fetch(
        `${process.env.REACT_APP_ASERVER}/api/kiosk/ticket/print`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ encryptedPayload: encryptedprintPayload }),

        }
      );

      if (!response.ok) throw new Error("Network response was not ok");
      const result = await response.json();

      if (result.success) {
        const ticketData=decryptPayload(result.ticket);
        // console.log('@@@ticketData--',ticketData);
        const printPayload = {

          payload: {
            tokenno: ticketData.token,
          status: ticketData.status,
          issueTime:ticketData.issueTime,
          serviceName: ticketData.serviceName,
          customerName: ticketData.customerName,
          customerEmail:ticketData.customerEmail,
          customerContact: ticketData.customerContact,
          },
          config: {
            branchId: result.settings.branchId,
            hasImageHeader: result.settings.hasImageHeader,
            imageHeader: result.settings.imageHeader,
            dateFormat: result.settings.dateFormat,
            contactNumber: result.settings.contactNumber,
            hasTextHeader: result.settings.hasTextHeader,
            hideTheTime: result.settings.hideTheTime,
            printDuplicate: result.settings.printDuplicate,
            printEstimatedWaitingTime: result.settings.printEstimatedWaitingTime,
            printQueuePosition: result.settings.printQueuePosition,
            paperSize: result.settings.paperSize,
            textHeader: result.settings.textHeader
          }
        };

 // === QZ Tray (Shreyans Printer) Printing ===
        await handlePrintViaQZTray(ticketData, result.settings);


      } else {
        console.error(result.message || "Error printing ticket.");
      }
    } catch (error) {
      console.error("Error submitting ticket:", error);
    } finally {
      // Always navigate to the kiosk screen
      setTicketModalOpen(false);

      navigate("/");
    }
  };

  const handleCancel = () => {
    navigate("/");
  };

  const dialogPaperProps = {
    sx: { maxWidth: 400 },
  };

  const formattedDate = new Date(
    appointmentDetails.scheduledOn
  ).toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const formattedTimeStart = new Date(
    `1970-01-01T${appointmentDetails.timeStart}`
  ).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
  const formattedTimeEnd = new Date(
    `1970-01-01T${appointmentDetails.timeEnd}`
  ).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#f0f2f5",
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
      }}
    >
      <Header />
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 2,
        }}
      >
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} md={6} mt={5}>
            <Card
              sx={{
                borderRadius: 6,
                boxShadow: 0,
                backgroundColor: "#ffffff",
                p: 5,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                border: "2px solid #e0e0e0",
              }}
            >
              <Typography variant="h5" fontWeight="500" sx={{ mb: 2 }}>
                Appointment Summary
              </Typography>

              <Box
                sx={{
                  width: "100%",
                  mb: 3,
                  p: 2,
                  borderRadius: 3,
                  backgroundColor: "#f5f5f5",
                  textAlign: "left",
                }}
              >
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Date:</strong> {formattedDate}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Time:</strong> {formattedTimeStart} -{" "}
                  {formattedTimeEnd}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Customer:</strong> {appointmentDetails.name}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <strong>Service:</strong> {appointmentDetails.serviceName}
                </Typography>
              </Box>

              {errorMessage && (
                <div
                  style={{
                    color: "red",
                    marginTop: "10px",
                    justifyContent: "right",
                  }}
                >
                  {errorMessage}
                </div>
              )}

              <Stack direction="row" spacing={2} mt={2} sx={{ width: "100%" }}>
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  sx={{
                    borderColor: "#1877f2",
                    color: "#1877f2",
                    borderRadius: 2,
                    height: 50,
                    width: "50%", // Ensures both buttons take equal width
                  }}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  variant="contained"
                  onClick={handleSubmit(onSubmit)}
                  sx={{
                    backgroundColor: "#1877f2",
                    color: "white",
                    borderRadius: 2,
                    height: 50,
                    width: "50%", // Ensures both buttons take equal width
                  }}
                >
                  Generate Ticket
                </Button>
              </Stack>

            </Card>
          </Grid>
        </Grid>
      </Box>

      {/* Ticket Modal */}
      <Dialog
        // fullWidth
        // maxWidth="xs"
        open={ticketModalOpen}
        onClose={() => setTicketModalOpen(false)}
        // PaperProps={dialogPaperProps}
        PaperProps={{
          sx: {
            borderRadius: 2,
            p: 2,
            boxShadow: 3,
            opacity: 1, // opacity should be within sx
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "center" }}>
          {/* <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "#1877f2" }}
          >
            Ticket Generated
          </Typography> */}
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center", p: 3 }}>
          <CheckCircleIcon style={{ color: "#4caf50", fontSize: 60 }} />
          {/* <Typography variant="h5" sx={{ mt: 1, color: "#4caf50" }}>
            Ticket Number: {ticketNumber}
          </Typography> */}
          <Typography variant="h5" sx={{ mt: 1, color: "#4caf50" }}>
            Token Number: {ticketToken}
          </Typography>

          <Typography variant="h6" sx={{ mt: 1 }}>
            Your ticket has been successfully generated!
          </Typography>
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#1877f2", color: "white", borderRadius: 2 }}
            onClick={handlePrint}
          >
            Print
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Print;
